import { render, staticRenderFns } from "./rolemgt.vue?vue&type=template&id=15e3ed69&scoped=true"
import script from "./rolemgt.vue?vue&type=script&lang=js"
export * from "./rolemgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e3ed69",
  null
  
)

export default component.exports